import { IOrderSteps } from "../../manhattan/order/types";

export default class CheckoutData {

  private readonly steps: IOrderSteps;

  constructor(steps: IOrderSteps) {
    this.steps = steps;
  }

}
